import classNames from 'classnames';
import React from 'react';
import { useId } from '@finn-no/troika-react-utils';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/**
 * Groups together and affect the styling of labels, controls and helptext.
 */
var Field = function Field(_ref) {
  var className = _ref.className,
      isDisabled = _ref.isDisabled,
      isInvalid = _ref.isInvalid,
      isReadOnly = _ref.isReadOnly,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "isDisabled", "isInvalid", "isReadOnly"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames('input input--no-bottom-margin', {
      'input--is-invalid': isInvalid,
      'input--is-disabled': isDisabled,
      'input--is-read-only': isReadOnly
    }, className)
  }, props));
};

Field.displayName = "Field";

/**
 * Use together with a form component to give additional context if the label
 * or placeholder isn't enough. It is also used for error messages.
 * Should be used inside a `<Field>` component.
 *
 * To be accessible, give this component an `id` and connect the form input to the helptext using `aria-describedby`.
 */
var HelpText = function HelpText(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames('input__sub-text', className)
  }, props));
};

HelpText.displayName = "HelpText";

/**
 * Use the Label component to connect a label with a form component in an accessible way.
 */
var Label = function Label(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for
    React.createElement("label", _extends({
      className: classNames('label', className)
    }, props))
  );
};

Label.displayName = "Label";

/**
 *
 * @param options.id The id of the field's control. Used as a base for the id of other elements. Generated automatically if not provided.
 * @param options.hasError If the form control is in an error/invalid state
 * @param options.hasHelpText If the form control has any help text
 */

function useField(options) {
  var id = useId(options.id);
  var helpTextId = "help__" + id;
  var helpTextProps = {
    id: helpTextId,
    // if the field is invalid/ in an error state, the helptext should have the `alert` role
    role: options.hasError ? 'alert' : undefined
  };
  var controlProps = {
    id: id,
    'aria-describedby': options.hasHelpText ? helpTextId : undefined,
    'aria-invalid': options.hasError,
    'aria-errormessage': options.hasError && options.hasHelpText ? helpTextId : undefined
  };
  return {
    controlProps: controlProps,
    helpTextProps: helpTextProps
  };
}

export { Field, HelpText, Label, useField };
//# sourceMappingURL=index.es.js.map
